import Select from "react-select";

const NewReactDropdownImproved = ({ options, func, text }) => {
  // This improved dropdown component includes a getOptions function which adds { label: x, value: x } to the options, so that an array of options can be passed to the component rather than { label: option, value: option }.

  const getOptions = (options) => {
    return options.map((x) => ({ label: x, value: x }));
  };

  const dropdownStyles = {
    singleValue: (styles) => {
      return {
        ...styles,
        color: "#fff",
      };
    },

    placeholder: (styles) => {
      return {
        ...styles,
        color: "rgba(255, 255, 255, 0.6)",
        // paddingTop: "0.7rem",
      };
    },

    input: (styles) => {
      return {
        ...styles,
        caretColor: "white",
        color: "white",
      };
    },

    control: (styles) => {
      return {
        ...styles,
        background: "linear-gradient(120deg, #23263a 60%, #1a1c28 100%)",
        outline: "none",
        caretColor: "white",
        color: "white",
        boxShadow: "0 0 8px 1px #00eaff",
        border: "2px solid #5fa8e6",
        borderRadius: "8px",
        "&:hover": {
          boxShadow: "0 0 12px 2px #00eaff",
        },
      };
    },
    menu: (styles) => {
      return {
        ...styles,
        background: "linear-gradient(120deg, #23263a 60%, #1a1c28 100%)",
        border: "2px solid #5fa8e6",
        borderRadius: "8px",
        zIndex: "999",
        position: "absolute",
        boxShadow: "0 0 8px 1px #00eaff",
      };
    },

    option: (styles) => {
      return {
        ...styles,
        background: "linear-gradient(120deg, #23263a 60%, #1a1c28 100%)",
        color: "#fff",
        "&:hover": {
          background: "linear-gradient(120deg, #2d3145 60%, #232632 100%)",
          boxShadow: "inset 0 0 8px rgba(0, 234, 255, 0.3)",
        },
      };
    },
  };

  return (
    <Select
      placeholder={text}
      onChange={func}
      options={getOptions(options)}
      styles={dropdownStyles}
      isSearchable={false}
      menuPortalTarget={document.body}
    />
  );
};

export default NewReactDropdownImproved;
